<template>
    <div class="elementor-element elementor-element-bcaf379 e-flex e-con-boxed e-con e-parent e-lazyloaded"
        data-id="bcaf379"
data-element_type="container"
data-e-type="container">
        <div class="e-con-inner">
            <div class="elementor-element elementor-element-3f95222 elementor-widget elementor-widget-heading"
                data-id="3f95222"
data-element_type="widget"
data-e-type="widget"
data-widget_type="heading.default">
                <h2 class="elementor-heading-title elementor-size-default">
FAQ
</h2>
            </div>
            <div class="elementor-element elementor-element-7eb69a3 elementor-widget elementor-widget-jet-listing-grid"
                data-id="7eb69a3"
data-element_type="widget"
data-e-type="widget"
                data-settings="{&quot;columns&quot;:&quot;1&quot;,&quot;columns_mobile&quot;:&quot;1&quot;}"
                data-widget_type="jet-listing-grid.default">
                <div class="jet-listing-grid jet-listing">
                    <div class="jet-listing-grid__items grid-col-desk-1 grid-col-tablet-1 grid-col-mobile-1 jet-listing-grid--421"
                        data-queried-id="12|WP_Post"
                        data-nav="{&quot;enabled&quot;:false,&quot;type&quot;:null,&quot;more_el&quot;:null,&quot;query&quot;:[],&quot;widget_settings&quot;:{&quot;lisitng_id&quot;:421,&quot;posts_num&quot;:6,&quot;columns&quot;:1,&quot;columns_tablet&quot;:1,&quot;columns_mobile&quot;:1,&quot;column_min_width&quot;:240,&quot;column_min_width_tablet&quot;:240,&quot;column_min_width_mobile&quot;:240,&quot;inline_columns_css&quot;:false,&quot;is_archive_template&quot;:&quot;&quot;,&quot;post_status&quot;:[&quot;publish&quot;],&quot;use_random_posts_num&quot;:&quot;&quot;,&quot;max_posts_num&quot;:9,&quot;not_found_message&quot;:&quot;No data was found&quot;,&quot;is_masonry&quot;:false,&quot;equal_columns_height&quot;:&quot;&quot;,&quot;use_load_more&quot;:&quot;&quot;,&quot;load_more_id&quot;:&quot;&quot;,&quot;load_more_type&quot;:&quot;click&quot;,&quot;load_more_offset&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0,&quot;sizes&quot;:[]},&quot;use_custom_post_types&quot;:&quot;&quot;,&quot;custom_post_types&quot;:[],&quot;hide_widget_if&quot;:&quot;&quot;,&quot;carousel_enabled&quot;:&quot;&quot;,&quot;slides_to_scroll&quot;:&quot;1&quot;,&quot;arrows&quot;:&quot;true&quot;,&quot;arrow_icon&quot;:&quot;fa fa-angle-left&quot;,&quot;dots&quot;:&quot;&quot;,&quot;autoplay&quot;:&quot;true&quot;,&quot;pause_on_hover&quot;:&quot;true&quot;,&quot;autoplay_speed&quot;:5000,&quot;infinite&quot;:&quot;true&quot;,&quot;center_mode&quot;:&quot;&quot;,&quot;effect&quot;:&quot;slide&quot;,&quot;speed&quot;:500,&quot;inject_alternative_items&quot;:&quot;&quot;,&quot;injection_items&quot;:[],&quot;scroll_slider_enabled&quot;:&quot;&quot;,&quot;scroll_slider_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;,&quot;mobile&quot;],&quot;custom_query&quot;:false,&quot;custom_query_id&quot;:&quot;&quot;,&quot;_element_id&quot;:&quot;&quot;,&quot;collapse_first_last_gap&quot;:false,&quot;list_tag_selection&quot;:&quot;&quot;,&quot;list_items_wrapper_tag&quot;:&quot;div&quot;,&quot;list_item_tag&quot;:&quot;div&quot;,&quot;empty_items_wrapper_tag&quot;:&quot;div&quot;}}"
                        data-page="1"
data-pages="1"
data-listing-source="posts"
data-listing-id="421"
data-query-id="">
                        <div v-for="(item, index) in list"
:key="item.postId"
                            :class="`jet-listing-grid__item jet-listing-dynamic-post-${item.postId}`"
                            :data-post-id="item.postId">
                            <div data-elementor-type="jet-listing-items"
data-elementor-id="421"
                                class="elementor elementor-421"
data-elementor-post-type="jet-engine">
                                <div class="elementor-element elementor-element-b56ec1f e-flex e-con-boxed e-con e-parent e-lazyloaded"
                                    data-id="b56ec1f"
data-element_type="container"
data-e-type="container">
                                    <div class="e-con-inner">
                                        <div class="elementor-element elementor-element-9fb7498 elementor-widget elementor-widget-toggle"
                                            data-id="9fb7498"
data-element_type="widget"
data-e-type="widget"
                                            data-widget_type="toggle.default">
                                            <div class="elementor-toggle">
                                                <div class="elementor-toggle-item">
                                                    <!-- 折叠标题：点击展开/收起，与 Elementor 的 elementor-active 样式一致 -->
                                                    <div :id="`elementor-tab-title-${index + 1}`"
                                                        class="elementor-tab-title"
:class="{ 'elementor-active': isOpen(item.postId) }"
                                                        data-tab="1"
role="button"
tabindex="0"
                                                        :aria-controls="`elementor-tab-content-${index + 1}`"
                                                        :aria-expanded="isOpen(item.postId)"
                                                        @click="toggle(item.postId)"
                                                        @keydown.enter.prevent="toggle(item.postId)"
                                                        @keydown.space.prevent="toggle(item.postId)">
                                                        <span class="elementor-toggle-icon elementor-toggle-icon-left"
                                                            aria-hidden="true">
                                                            <span v-show="!isOpen(item.postId)"
class="elementor-toggle-icon-closed">
<svg class="e-font-icon-svg e-fas-angle-down"
                                                                    viewBox="0 0 320 512"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
                                                                </svg>
</span>
                                                            <span v-show="isOpen(item.postId)"
class="elementor-toggle-icon-opened">
<svg class="elementor-toggle-icon-opened e-font-icon-svg e-fas-angle-up"
                                                                    viewBox="0 0 320 512"
                                                                    xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z" />
                                                                </svg>
</span>
                                                        </span>
                                                        <span class="elementor-toggle-title">
{{ item.title }}
</span>
                                                    </div>

                                                    <!-- Elementor 全局 .elementor-tab-content{display:none}，v-show 展开时会去掉内联 display，内容仍被样式表隐藏，需显式 block -->
                                                    <div :id="`elementor-tab-content-${index + 1}`"
                                                        class="elementor-tab-content elementor-clearfix"
data-tab="1"
                                                        role="region"
:aria-labelledby="`elementor-tab-title-${index + 1}`"
                                                        :style="{ display: isOpen(item.postId) ? 'block' : 'none' }">
                                                        {{ item.content }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FaqPanel",
    data() {
        return {
            /** FAQ：openIds 为已展开项的 postId 列表（可多选）；默认全部收起 */
            openIds: [],
            list: [
                {
                    postId: 57466,
                    title: "What is RepGalaxy?",
                    content:
                        "RepGalaxy is a spreadsheet made easy. It delivers the easiest finding & buying experience for new and veteran replica buyers."
                },
                {
                    postId: 57465,
                    title: "What makes RepGalaxy different?",
                    content:
                        "RepGalaxy focuses on transparency, real testing, and a curated selection instead of overwhelming you with thousands of random listings. Everything shown is filtered through experience, expertise, and actual quality standards."
                },
                {
                    postId: 57464,
                    title: "Is it easy to use?",
                    content:
                        "Yes. RepGalaxy is built to be simple, intuitive, and beginner-friendly. You can browse categories and explore products that I’ve already tested — all in a straightforward, intuitive layout that requires no prior experience with agents or CNFans."
                },
                {
                    postId: 1348,
                    title: "How often is RepGalaxy updated?",
                    content:
                        "Regularly. As new orders arrive, new items get tested, or better sellers are found, the site is updated with fresh recommendations and improved insights."
                },
                {
                    postId: 842,
                    title: "Does RepGalaxy verify product authenticity or quality?",
                    content:
                        "RepGalaxy does not verify, certify, or guarantee the authenticity or quality of any products listed on external platforms. We are not the seller, distributor, or intermediary for any item shown on our website, and we do not participate in transactions between buyers and suppliers. All product information, images, prices, and descriptions are provided directly by third-party sellers, and may vary. Users are responsible for evaluating suppliers and making informed purchasing decisions. RepGalaxy simply aggregates publicly available data to make browsing easier and more transparent."
                }
            ]
        };
    },
    methods: {
        isOpen(postId) {
            return this.openIds.indexOf(postId) !== -1;
        },
        /** 点击切换该项展开/收起，不影响其它已展开项 */
        toggle(postId) {
            const i = this.openIds.indexOf(postId);
            if (i !== -1) {
                this.openIds.splice(i, 1);
            } else {
                this.openIds.push(postId);
            }
        }
    }
};
</script>

<style scoped>
/* 折叠标题可点击提示（原导出 HTML 无交互样式） */
.elementor-tab-title {
    cursor: pointer;
    user-select: none;
}
</style>